import { createBrowserHistory } from "history";
import { applyMiddleware, compose, createStore } from "redux";
import thunkMiddleware from "redux-thunk";


import reducers from "./reducers";

const history = createBrowserHistory();

const middlewares = [thunkMiddleware];
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const configureStore = initialState => {
  // initialState = getItemSession('state');
  // if (initialState) initialState = JSON.parse(initialState);
  // else initialState = 'undefined';
  const store = createStore(reducers(history), initialState, composeEnhancers(applyMiddleware(...middlewares)));
  return store;
};

export { history };
export default configureStore;
